export function TopRibbonLoader() {
    return (
        <>
            <div className="absolute inset-0 w-full">
                <div className="h-1.5 w-full overflow-hidden bg-primary-100">
                    <div className="origin-left-right animate-progress h-full w-full bg-primary-500" />
                </div>
            </div>
        </>
    );
}
